import request from '@/utils/request'

/**
 * 上传文件
 * @param {File} file - 文件对象
 * @returns {Promise} 上传结果
 */
export function uploadFile(file) {
  const formData = new FormData()
  formData.append('file', file)
  
  return request({
    url: '/system/file/upload',
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

/**
 * 批量上传文件
 * @param {File[]} files - 文件数组
 * @returns {Promise} 上传结果
 */
/**
 * 批量保存附件（先删后增）
 * @param {number} subjectId 业务ID（试卷ID）
 * @param {number} type 业务类型（1=试卷答题图片）
 * @param {Array<{url: string, name?: string}>} attachments 附件列表
 * @returns {Promise}
 */
export function batchSaveAttachments(subjectId, type, attachments) {
  return request({
    url: '/system/attachment/batchSave',
    method: 'post',
    params: { subjectId, type },
    data: attachments
  })
}

/**
 * 查询附件列表
 * @param {number} subjectId 业务ID（试卷ID）
 * @param {number} type 业务类型（1=试卷答题图片）
 * @returns {Promise<Array<{url: string, name: string}>>}
 */
export function getAttachments(subjectId, type) {
  return request({
    url: '/system/attachment/list',
    method: 'get',
    params: { subjectId, type }
  })
}

export function uploadFiles(files) {
  const formData = new FormData()
  files.forEach(file => {
    formData.append('files', file)
  })
  
  return request({
    url: '/system/file/uploadBatch',
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}
